import { getPaginated } from '@/utils/api';
import { useQuery } from '@tanstack/react-query';
import { B2bEvent, featureKeys, featurePath } from '.';

const FIVE_MINUTES = 1000 * 60 * 5;

const useEventColumn = (column: string, page: number) =>
  useQuery({
    queryKey: featureKeys.events(column, page),
    queryFn: () => getPaginated<B2bEvent>(`${featurePath}/events/${column}`, { page }),
    refetchInterval: FIVE_MINUTES,
    throwOnError: false,
  });

export const useRecentBooked = (page: number) => useEventColumn('recent-booked', page);
export const useUpcomingEvents = (page: number) => useEventColumn('upcoming', page);
export const useRecentlyCompleted = (page: number) => useEventColumn('recently-completed', page);
